/**
 * * Enum de las APIs de la aplicación para comunicación con el BackEnd
 */
export enum THEMES {
   ADOMICILIO = 'adomicilio-theme',
   TRAMONTECH = 'tramon-theme',
}
